import { v4 as uuidv4 } from "uuid";

import { BOOK_CHAPTER_UPDATED } from "redux/types";
import bookChaptersUpdated from "./bookChaptersUpdated";
import { updateConfigAI } from "../configAI/configAiUpdate";

export default function bookChapterAdd(osbn, chapter, book, organisation) {
    return async (dispatch, getState) => {

        const chapterId = uuidv4();

        dispatch({
            type: BOOK_CHAPTER_UPDATED,
            osbn,
            chapterId,
            chapter
        });

        await dispatch(bookChaptersUpdated(osbn));

        const { config } = getState().configAI;
        let updatedMap = config.aiMap || [];

        updatedMap.push({ laws: "", industry: "", branch: "", isEnabled: false, chapterId })

        updatedMap = stripTypename(updatedMap);
        const configData = {
            id: config.id,
            organisationId: organisation.id,
            bookId: book.id,
            apikey: config.apikey ?? "",
            prompt: config.prompt ?? "",
            provider: config.provider ?? "",
            model: config.model,
            osbn,
            aiMap: updatedMap,
        };

        await dispatch(updateConfigAI(configData));

        return chapterId;
    };
}

const stripTypename = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map(stripTypename);
    } else if (obj && typeof obj === "object") {
        const cleaned = {};
        for (const key in obj) {
            if (key === "__typename") continue;
            cleaned[key] = stripTypename(obj[key]);
        }
        return cleaned;
    }
    return obj;
};